import ApiFactory from "@/services/ApiFactory.js";

export default {
	async getItemApiList(params,customInput) {
        let res = await ApiFactory.post("/product/ism/custominput/" + params, {inputList:customInput});
        console.log(res);
        return res.data;
    },
    async getLocation(params) {
        let res = await ApiFactory.get("/product/locations?category_id=" + params);
        return res.data;
    },
    async getAutoComplete(params) {
        let res = await ApiFactory.get("/product/ism/searchbox?freeText=" + params);
        return res.data;
    },
    async getProduct(displayOrder, params) {
        let res = await ApiFactory.post("/product/ism/summary?displayOrder=" + displayOrder, params);
        return res.data;
    },
    async getProductDetail(params) {
        let res = await ApiFactory.get("/product/ism/detail/" + params);
        return res.data;
    },
    async getCategory(params) {
        let res = await ApiFactory.get("/product/categories?location_id=" + params);
        return res.data;
    },
    async getPrice(params) {
        console.log(params);
        let res = await ApiFactory.get("/product/ism/price/" + params.code + "/" + params.date + "/" + params.itemId);
        return res.data;
    },
    async getCarRentalCountries() {
        let res = await ApiFactory.get("/product/car/rental/countries");
        return res.data;
    },
    async getCarRentalCities(params) {
        let res = await ApiFactory.get("/product/car/rental/cities/" + params);
        return res.data;
    },
    async getCarRentalRegions(params) {
        let res = await ApiFactory.get("/product/car/rental/regions/" + params);
        return res.data;
    },
    async getCarRentalSuppliers() {
        let res = await ApiFactory.get("/product/car/supplier");
        return res.data;
    },
    async getCarRentalModels(params) {
        let res = await ApiFactory.get("/product/car/model/" + params);
        return res.data;
    },
    async getCarRentalProducts(displayOrder, params) {
        let res = await ApiFactory.post("/product/car/summary?displayOrder=" + displayOrder, params);
        return res.data;
    }, 
    async getCarRentalDetail(params) {
        let res = await ApiFactory.post("/product/car/detail", params);
        return res.data;
    },
    async getCarBranchList(param) {
        let res = await ApiFactory.get("/product/car/branch/" + param);
        return res.data;
    },
    async getCarOptionList(param) {
        let res = await ApiFactory.get("/product/car/option/" + param);
        return res.data;
    }
}